import routes from '@/config/routes';
import { v3Get, v3Post } from '@/api/axios.instance.V3';
import type { IGigCampaign } from '@/store/admin/types/types';
import type { AxiosResponse } from 'axios';
import type { ApiResponse } from '../types';

const saveCampaign = async (campaign: IGigCampaign): Promise<AxiosResponse> => {
  return await v3Post(routes.backendUrl.gigCampaignAdmin.create, campaign);
};

const getCampaignById = (campaignId: number): ApiResponse =>
  v3Get(`${routes.backendUrl.gigCampaignAdmin.getCampaignById}${campaignId}`);

const getLatestCampaignByGigId = (gigId: number): ApiResponse =>
  v3Get(`${routes.backendUrl.gigCampaignAdmin.getLatestCampaignByGigId}${gigId}`);

const getCampaignCountryProfileList = (): ApiResponse =>
  v3Get(`${routes.backendUrl.gigCampaignAdmin.getCampaignCountryProfileList}`);

const getVocabRatioTypeList = (): ApiResponse => v3Get(`${routes.backendUrl.vocab.getVocabRatioTypeList}`);

const getVocabRatioProfileList = (): ApiResponse => v3Get(`${routes.backendUrl.vocab.getVocabRatioProfileList}`);

export const gigCampaignAdminApi = {
  saveCampaign,
  getCampaignById,
  getLatestCampaignByGigId,
  getCampaignCountryProfileList,
  getVocabRatioTypeList,
  getVocabRatioProfileList,
};
